<div *ngIf="isLoading" class="height-100 width-100 twc-d-flex align-center justify-content-center">
    <twc-loader size="large"></twc-loader>
</div>

<div class="position-absolute twc-mt-2 tools" *ngIf="isResetExtentEnabled()">
    <cw-toolbar [toolbarDefinition]="toolbar" (selectOption)="onSelectOption($event)"></cw-toolbar>
</div>

<div class="container-sites-map width-100 height-100" #containerSitesMap>
    <div class="width-100 height-100" #sitesMap>
    </div>
</div>